'use client';
// Seguimiento de /planes y /planesbeta (igual que tenía PlanesClient):
// LandingTracker, el banner LANZAMIENTO25 y un ViewContent por visita, a Meta
// (pixel) y al CAPI (/api/marketing/view-content, que deduplica por IP y día).
// El ViewContent alimenta la audiencia VieronPlanes-30d del retargeting.
import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import LandingTracker from '@/components/analytics/LandingTracker';
import { trackFbq } from '@/components/analytics/MetaPixel';
import PromoCountdownBanner from '@/components/marketing/PromoCountdownBanner';

export default function PlanesTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const disparado = useRef(false);

  useEffect(() => {
    if (disparado.current) return;
    disparado.current = true;
    const pageType = pathname?.includes('planesbeta') ? 'planesbeta' : pathname?.includes('planes') ? 'planes' : null;
    if (!pageType) return;
    const planId = searchParams.get('plan') || undefined;
    trackFbq('track', 'ViewContent', {
      content_name: pageType,
      content_category: 'pricing',
      ...(planId && { content_ids: [planId] }),
    });
    fetch('/api/marketing/view-content', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageType, planId }),
      keepalive: true,
    }).catch(() => {});
  }, [pathname, searchParams]);

  return (
    <>
      <LandingTracker />
      <PromoCountdownBanner />
    </>
  );
}
